<div *ngIf="showLoading" class="flexCenter">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="!showLoading">
  <mat-horizontal-stepper class="HorizontalStepper" [linear]=true disableRipple="true" #stepper>
    <mat-step [stepControl]="CoordinateSearchForm" [editable]="isEditable">
      <ng-template matStepLabel>{{"stpr_CoordinateSearch" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </ng-template>
      <app-coordinate-search-page (submitFormular)="updateRequestModel(true)" [OverviewForm]="OverviewForm"
        [CoordinateSearchFormGroup]="CoordinateSearchForm"></app-coordinate-search-page>
    </mat-step>
    <mat-step [stepControl]="MapForm" [editable]="isEditable">
      <ng-template matStepLabel>{{"stpr_Map" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </ng-template>
      <app-map-page (submitFormular)="updateRequestModel(true)" [childFormInput]="MapForm"  [OverviewForm]="OverviewForm"
        [CoordinateSearchFormGroup]="CoordinateSearchForm" [stepper]="stepper">
      </app-map-page>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{"stpr_RequestOverview" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
      </ng-template>
      <app-request-overview [childFormInput]="OverviewForm" (onSubmit)="disableEditable()">
      </app-request-overview>
    </mat-step>
  </mat-horizontal-stepper>
</div>